import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DomainSelectionPage from './pages/DomainSelectionPage/DomainSelectionPage';
import SubscriptionSelectionPage from './pages/SubscriptionSelectionPage/SubscriptionSelectionPage';
import ScanningPage from './pages/ScanningPage/ScanningPage';
import DetectedFaultPage from './pages/DetectedFaultPage/DetectedFaultPage';
import unidentifiedFaultPage from './pages/UnidentifiedFaultPage/UnidentifiedFaultPage'
import { detectFault } from './problemDomainAsyncThunk';
import {
  goToDomainSelection,
  goToSubscriptionSelection,
  selectSubscription,
  goBackToSubscriptionSelection,
  goToDetectedFaultPage,
  goToUnidentifiedFaultPage,
  resetProblemDomainFlow,
} from './problemDomainBlockSlice';
import { problemDomainPages } from './problemDomainPages';

export default function ProblemDomainFlow(props) {
  const dispatch = useDispatch();
  const {
    page,
    selectedWorld,
    selectedSubscription,
    selectedDomainContentLinkId,
    detectedFaultResult,
    skippedSubscriptionSelection,
  } = useSelector(
    (state) => state.problemDomainBlock,
  );

  useEffect(() => {
    return () => {
      dispatch(resetProblemDomainFlow());
    };
  }, [dispatch]);

  const handleContinueToFaultFlow = useCallback(
    (world, domainContentLinkId) => {
      dispatch(goToSubscriptionSelection({ world, domainContentLinkId }));
    },
    [dispatch],
  );

  const handleBackToDomainSelection = useCallback(() => {
    dispatch(goToDomainSelection());
  }, [dispatch]);

  const handleSubscriptionSelected = useCallback(
    (subscription, options = {}) => {
      dispatch(
        selectSubscription({
          subscription,
          skippedSelection: Boolean(options.skippedSelection),
        }),
      );
    },
    [dispatch],
  );

  const handleBackFromScanning = useCallback(() => {
    if (skippedSubscriptionSelection) {
      dispatch(goToDomainSelection());
      return;
    }

    dispatch(goBackToSubscriptionSelection());
  }, [dispatch, skippedSubscriptionSelection]);

  const handleUnidentifiedFault = useCallback(() => {
    dispatch(goToUnidentifiedFaultPage());
  }, [dispatch]);

  const handleIdentifiedFault = useCallback(
    (result) => {
      dispatch(goToDetectedFaultPage(result));
    },
    [dispatch],
  );

  switch (page) {
    case problemDomainPages.scanningPage:
      return React.createElement(ScanningPage, {
        iContent: props.iContent,
        productWorld: selectedWorld,
        domainContentLinkId: selectedDomainContentLinkId,
        selectedSubscription,
        onBack: handleBackFromScanning,
        onIdentifiedFault: handleIdentifiedFault,
        onUnidentifiedFault: handleUnidentifiedFault,
        detectFault,
      });

    case problemDomainPages.subscriptionSelectionPage:
      return React.createElement(SubscriptionSelectionPage, {
        iContent: props.iContent,
        productWorld: selectedWorld,
        domainContentLinkId: selectedDomainContentLinkId,
        onBack: handleBackToDomainSelection,
        onSelectSubscription: handleSubscriptionSelected,
      });

    case problemDomainPages.detectedFaultPage:
      return React.createElement(DetectedFaultPage, {
        iContent: props.iContent,
        selectedSubscription,
        detectedFaultResult,
        onBack: handleBackToDomainSelection,
      });

    case problemDomainPages.unidentifiedFaultPage:
      return React.createElement(unidentifiedFaultPage, {
        iContent: props.iContent,
        selectedSubscription,
        onBack: handleBackToDomainSelection,
      });

    case problemDomainPages.domainSelectionPage:
    default:
      return React.createElement(DomainSelectionPage, {
        iContent: props.iContent,
        onContinueToFaultFlow: handleContinueToFaultFlow,
      });
  }
}
